__turbopack_context__.v({
  "calendarHeaderLevel": "mantineDatePickerInput-module-scss-module__wUrxJG__calendarHeaderLevel",
  "day": "mantineDatePickerInput-module-scss-module__wUrxJG__day",
  "dropdown": "mantineDatePickerInput-module-scss-module__wUrxJG__dropdown",
  "input": "mantineDatePickerInput-module-scss-module__wUrxJG__input",
  "weekday": "mantineDatePickerInput-module-scss-module__wUrxJG__weekday",
});
